<template>
	<v-card flat>
		<v-card-text>
			<surveyor-select v-model="filters.surveyors"/>
			<v-switch label="לפי שנה" v-model="byYear" >{{byYear}}</v-switch>
			<smart-input v-if="byYear" name="year" v-model="filters.year" label="שנה" type="number" :max="max" min="2000" step="1" ></smart-input>
			<v-date-picker v-else full-width v-model="filters.month" type="month" color="green lighten-1" header-color="primary"></v-date-picker>
			<smart-input required label="שם קובץ" v-model="filters.file_name"></smart-input>
		</v-card-text>
		<v-card-actions>
			<v-btn slot="actions" :disabled="!canExport" color="success" btn @click="exportExcel">
				{{$t("pages.measurementTable.exportExcel")}}
			</v-btn>
			<v-spacer/>
			<v-btn slot="actions" :disabled="!(canExport && filters.surveyors.length ===1)" color="primary" btn @click="measurementReport">
				דוח פירוט מדידות
			</v-btn>
			<v-btn slot="actions" :disabled="!(canExport && filters.surveyors.length ===1)" color="warning" btn @click="htmReport">
				דוח HTM
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>

	import SurveyorSelect from "dev/view/users/SurveyorSelect";

	export default {
		name: "surveyor-monthly-report",
		props: [],
		components: {SurveyorSelect},
		data() {
			return {
				byYear:true,
				max:new Date().getFullYear(),
				filters: {
					year:new Date().getFullYear(),
					month: null,
					surveyors: [],
					file_name: "דוח מודד"
				},

			};
		},
		computed: {
			isClient() {
				return this.$store.getters.isClient;
			},
			basicUrl() {
				return this.$store.state.ConfigModule.request.baseUrl;
			},
			canExport() {
				return this.byYear ? this.filters.year:this.filters.month;
			}
		},
		methods: {
			getFilters() {
				let query = new URLSearchParams();
				Object.keys(this.filters).forEach(key => query.set(key, this.filters[key]));
				return query;
			},
			exportExcel() {

				window.open(`${this.basicUrl}/export/surveyor?a=1&${this.getFilters()}`);
			},
			htmReport() {
				window.open(`${this.basicUrl}/export/htm/surveyor?a=1&${this.getFilters()}`);
			},
			measurementReport() {
				window.open(`${this.basicUrl}/export/measurement/surveyor?a=1&${this.getFilters()}`);
			}

		},
		watch:{
			byYear(){
				if (this.byYear){
					this.filters.month=null;
				}
			}
		}

	};
</script>

<style scoped>

</style>
